/* eslint-disable max-len */
import { combineActions, handleActions } from 'redux-actions';
import produce from 'immer';
import * as types from '@src/store/types';
import forEach from 'lodash/forEach';
import update from 'immutability-helper';

const RESPONSE_PROTECT_MESSAGE = '信用卡授權失敗_卡號保護中';

const initialState = {
	groupErrorMessage: '',
	inputErrorMessages: {},
};

export default handleActions(
	{
		[types.EMAIL_LOGIN_FAIL](state, { payload: { response = {} } }) {
			const { status, data } = response;

			return produce(state, draft => {
				if (status === 400 || status === 403) {
					draft.groupErrorMessage = data?.raw.includes('is deactivated.') ? 'share:auth:employee_login:deactivated_error' : 'share:auth:employee_login:login_error';
				}
			});
		},
		[types.EMAIL_REGISTER_FAIL](state, { payload: { response = {} } }) {
			const { status, data } = response;

			return produce(state, draft => {
				if (status === 409 || data?.message === 'Conflict Email') {
					draft.inputErrorMessages = {
						...draft.inputErrorMessages,
						email: 'share:auth:register:account_existed',
					};
				}
			});
		},

		[types.FORGET_PASSWORD_FAIL](state, { payload: { response = {} } }) {
			const { status } = response;

			return produce(state, draft => {
				if (status === 404) {
					draft.inputErrorMessages = {
						...draft.inputErrorMessages,
						email: 'share:auth:forget_password:email_error',
					};
				}
			});
		},

		[types.CHECK_HOST_NAME_EXIST_DONE](state, { payload = [] }) {
			return produce(state, draft => {
				draft.inputErrorMessages.hostName = 'training:site:create:name_error';
			});
		},
		[types.ADD_SCHOOL_FAIL](state, { payload: { response = {} } }) {
			const { status, data } = response;

			return produce(state, draft => {
				if (status === 400) {
					const { fields } = data;

					forEach(fields, item => {
						switch (item) {
						case 'name':
							draft.inputErrorMessages.name = 'training:site:create:name_error';
							break;
						case 'hostname':
							draft.inputErrorMessages.hostName = 'training:site:create:name_error';
							break;
						case 'company_no':
							draft.inputErrorMessages.companyNo =
									'training:site:create:company_no_error';
							break;
						default:
							break;
						}
					});
				}
			});
		},
		[types.ADD_CREDIT_CARD_FAIL](state, { payload }) {
			const isCreditCardProtected = decodeURI(payload.error.response.data.i18n_msg)
				.indexOf(RESPONSE_PROTECT_MESSAGE) > -1;

			return update(state, {
				groupErrorMessage: {
					$set: isCreditCardProtected ?
						'training:checkout:payment:error:retry_after_seconds' :
						'training:checkout:payment:credit_card:credit_card_error',
				},
			});
		},
		[types.CONFIRM_MOBILE_FAIL](state, { payload: { response } }) {
			return produce(state, draft => {
				draft.groupErrorMessage = 'share:auth:confirm_mobile:verification_error';
			});
		},
		[combineActions(
			types.EMAIL_LOGIN_CALL,
			types.ADD_CREDIT_CARD_CALL,
			types.EMAIL_RE_SEND_CALL,
			types.CONFIRM_MOBILE_CALL,
		)](state, { payload }) {
			return produce(state, draft => {
				draft.groupErrorMessage = '';
			});
		},
		[types.SET_ERROR_MESSAGE](
			state,
			{ payload: { groupErrorMessage, inputErrorMessages } },
		) {
			return produce(state, draft => {
				if (groupErrorMessage) {
					draft.groupErrorMessage = groupErrorMessage;
				}

				if (inputErrorMessages) {
					draft.inputErrorMessages = inputErrorMessages;
				}
			});
		},
		[types.CLEAR_ERROR_MESSAGE](state, { payload }) {
			return initialState;
		},
		[types.CLEAR_INPUT_ERROR_MESSAGE](state, { payload: { name } }) {
			return produce(state, draft => {
				if (draft.inputErrorMessages[name]) {
					draft.inputErrorMessages[name] = '';
				}
			});
		},
	},
	initialState,
);
